"use client";

import { usePathname, useRouter } from "@/navigation";
import { useLocale, useTranslations } from "next-intl";

const LOCALES = [
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
] as const;

export default function LanguageSelector() {
  const router = useRouter();
  const pathname = usePathname();
  const locale = useLocale();
  const t = useTranslations("component.navigation");

  return (
    <div
      role="group"
      aria-label={t("languageLabel")}
      className="inline-flex rounded-full border border-stroke bg-white p-0.5 text-xs font-semibold dark:border-stroke-dark dark:bg-white/5"
    >
      {LOCALES.map(({ code, label }) => {
        const active = locale === code;
        return (
          <button
            key={code}
            type="button"
            aria-pressed={active}
            onClick={() => {
              if (!active) router.push(pathname, { locale: code });
            }}
            className={`rounded-full px-2.5 py-1 transition ${
              active
                ? "bg-black text-white dark:bg-white dark:text-black"
                : "text-body-color hover:text-black dark:text-body-color-dark dark:hover:text-white"
            }`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
